import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Posts from './pages/Posts';
import Comments from './pages/Comments';
import AdminComments from './pages/AdminComments';
import Users from './pages/Users';
import VerifyOTP from './pages/VerifyOTP';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/comments" element={<Comments />} />
        <Route path="/admin-comments" element={<AdminComments />} />
        <Route path="/users" element={<Users />} />
        <Route
          path="*"
          element={<Navigate to={localStorage.getItem('accessToken') ? '/dashboard' : '/'} replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
